// 路由守卫
import router from '@/router';
// import store from '@/store';
//
// import { getPermission } from '@/api/user';
import { getCookie } from '@/utils/cookies';
// import { megError } from '@/utils/message';
//
// // 判断是否有登录权限
// function hasPermission (route) {
//   if (!route.meta || !route.meta.auth) { // 不需要验证的权限验证的页面
//     return true;
//   }
//
//   // 需要验证的权限验证的页面
//   return store.getters.permissionList.indexOf(route.meta.auth) !== -1;
// }

// 免登陆白名单:  所有人都有权限登录的页面
const whiteList = ['/login'];

router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) > -1) {
    next();
  } else {
    if (getCookie('userName')) {
      next();
      
      // 页面级权限控制
      // if (store.getters.hasPermission) {
      //   if (hasPermission(to)) {
      //     next();
      //   } else {
      //     // 无权限页面
      //     next({ path: '/error' });
      //   }
      // } else {
      //   getPermission()
      //     .then(res => {
      //       store.dispatch('setPermissionList', res.page_list)
      //         .then(() => {
      //           next({ ...to, replace: true });
      //         });
      //     })
      //     .catch(() => {
      //       megError('身份已过期请重新登录');
      //       store.dispatch('logOut')
      //         .then(() => {
      //           next({ path: '/login' });
      //         });
      //     });
      // }
    } else {
      next({ path: '/login' });
    }
  }
});
